// export const SERVER_URI="https://skyjumperadmin-api.ypay.tech/api/v1"

// export const SERVER_URI="http://192.168.0.19:3001/api/v1"


// export const SERVER_URI="http://20.197.49.59:3004/api/pos/v1"


export const SERVER_URI="https://posapi.skyjumpertp.com/api/pos/v1"



export const TEST_URI = "https://test.ypay.tech"
